require("./polar-native-ads-plugin");
require("./polar-page.scss");

(function($, mm) {
    const $polarSection = $(".ncc-polar-section");
    const $placementDivs = $polarSection.find(".ncc-polar-list li > div");
    //taking Bikepoint into account
    var site = $polarSection.data("polar-site");
    //anything between 3-5
    var cardCount = 0;

    var initializeSlider = function() {
        cardCount++;

        if (cardCount < 3) {
            return;
        }

        var cardWidth = $(".ncc-polar-ad").width() + 40;
        $(".ncc-polar-next").on("click",
            function() {
                const currentPosition = ($(".ncc-polar-list").css("transform") !== "none")
                    ? $(".ncc-polar-list").css("transform").split(/[()]/)[1].split(",")[4]
                    : 0;
                if (Math.abs(currentPosition) >= cardWidth) return; // Need to accommodate for more than 3 cards
                $(".ncc-polar-list").css("transform", `translateX(${Math.abs(currentPosition) - cardWidth}px)`);
            });

        $(".ncc-polar-previous").on("click",
            function() {
                const currentPosition = ($(".ncc-polar-list").css("transform") !== "none")
                    ? $(".ncc-polar-list").css("transform").split(/[()]/)[1].split(",")[4]
                    : 0;
                if (Math.abs(currentPosition) <= 0) return;
                $(".ncc-polar-list").css("transform", `translateX(${Math.abs(currentPosition) - cardWidth}px)`);
            });
    };

    mm.onNoFill = function(location) {
        cardCount--;
        const $emptyPlacement = $(location);
        $emptyPlacement.parent().remove();
        initializeSlider();
    };

    var onContentCardLoad = function() {
        initializeSlider();
    };


    $.each($placementDivs,
        function(idx, placement) {
            const currentDivId = +$(placement).attr("id");

            const tags = JSON.parse(mm.AdTags);
            tags.tile = currentDivId;

            mm.registerPolarNative({
                area: "searchresults",
                label: `content-card-pos ${++idx}`,
                site: site,
                location: `.ncc-polar-section div#${currentDivId}`,
                onRender: function($element) {
                    onContentCardLoad();
                },
                custom: tags
            });
        });
})(jQuery, window.CSN.MediaMotive);